import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-16 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image + How to Book */}
          <div className="order-2 md:order-1 space-y-6">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_kove-bookings/artifacts/s3gw41dd_IMG_8497.jpeg"
                alt="Professional hair colour process at Kove"
                className="w-full h-auto"
              />
            </div>
            
            {/* How to Book */}
            <div className="bg-sage-50 border-l-4 border-sage-600 p-4 md:p-5 rounded-r-lg">
              <h3 className="text-base md:text-lg font-normal text-sage-900 mb-3">How to Book</h3>
              <p className="text-sm text-gray-700 font-light mb-2">Text us with:</p>
              <ul className="text-sm text-gray-600 font-light space-y-1 ml-4 list-disc">
                <li>Photo of your current hair</li>
                <li>Inspiration pictures</li>
                <li>Brief colour history</li>
                <li>Preferred dates/times</li>
              </ul>
              <p className="text-xs text-gray-500 font-light italic mt-3">
                We can't answer calls while with clients, so texting is preferred
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 md:order-2 space-y-4 md:space-y-5">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-gray-900 leading-tight">
              Your Hair,{' '}
              <span className="italic text-sage-600">Our Passion</span>
            </h2>

            <p className="text-base md:text-lg text-gray-600 font-light leading-relaxed">
              Kove is an intimate salon based in Middleton Loop, tucked away conveniently just off the main street of Albany. Owned and operated by Tess and Hayley, two local stylists with a passion for the industry, we offer exclusively 1-on-1 personalised service, meaning we can turn 100% of our attention to our clients sitting in our chairs.
            </p>

            <p className="text-base md:text-lg text-gray-600 font-light leading-relaxed">
              Focusing our education on colour work and blonde transformations, this is where our passion for hairdressing continues to flourish!
            </p>

            <p className="text-sm md:text-base text-gray-600 font-light leading-relaxed italic">
              We specialise in creating beautiful transformations for bob-length hair and longer, allowing us to perfect our craft in colour work and styling excellence.
            </p>

            <div className="pt-2 md:pt-4">
              <a
                href="sms:0475409162"
                className="inline-flex items-center justify-center bg-sage-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full hover:bg-sage-700 transition-all duration-300 font-normal tracking-wide shadow-lg text-sm md:text-base"
              >
                TEXT TO BOOK
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;